import { GetPageByRouteQuery } from "apollo"
import { BlockRenderer } from "ui"
import { extractProperty, getBreadCrumbs, transformProperties } from "utils"

type Props = {
  data: GetPageByRouteQuery
  locale: string
}

const components = {
  heroBanner: () => import("../Common/Hero"),
  tabsContent: () => import("../Common/TabsContent"),
  adynamicTitleAndContant: () => import("../Common/DynamicTitle"),
  fAQ: () => import("../Common/AccordionFAQ"),
}

export default function Eligibility({ data, locale }: Props) {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)
  return (
    <>
      {blocks?.blocks?.map(
        // TO DO : HOW TO FIND BLOCK TYPE IN GENERATED GRAPHQL TYPES
        (block: any, index: number) => {
          let blockProps = {}
          if (block.blockType === "fAQ") {
            const heroBlock = blocks.blocks.find(
              (b: any) => b.blockType === "heroBanner",
            )
            const pageMainTitle = extractProperty(
              heroBlock,
              "pageMainTitle",
            ) as string
            blockProps = { pageTitle: pageMainTitle }
          }
          return (
            <BlockRenderer
              key={index}
              blockType={block.blockType}
              blockData={block}
              components={components}
              locale={locale}
              props={{ breadCrumbs, paddingBottom: true, ...blockProps }}
            />
          )
        },
      )}
    </>
  )
}
